module.exports = __webpack_public_path__ + "media/customizations/hawaiian/logo-f448e86f2aaf86f8ec5657b314e522a2.png";